<template>
  <div>
    <div class="roundCss">
      <hmd-round v-if="value === '尚未往来'" type="nothave"></hmd-round>
      <hmd-round v-if="value === '正在往来'" type="having"></hmd-round>
      <hmd-round v-if="value === '曾经往来'" type="once"></hmd-round>
      <div>{{value}}</div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  isGlobal: true,
  name: "BooleanStatusDescription",
  props: {
    value: { type: String },
  },
});
</script>
<style lang="less" scope>
  .roundCss {
    display: flex;
    justify-items: center;
  }
</style>